var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWalkingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 23.654,
    viewBox: "0 0 15 23.654",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 400"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 426",
    d: "M14.654 6.115a2.308 2.308 0 1 0-2.308-2.308 2.314 2.314 0 0 0 2.308 2.308zm-4.269 3.923L7.431 23.781a1.149 1.149 0 0 0 1.131 1.373h.092a1.159 1.159 0 0 0 1.131-.9l1.869-7.177 2.423 2.308V24a1.154 1.154 0 1 0 2.308 0v-5.354a2.3 2.3 0 0 0-.715-1.673l-1.708-1.627.692-3.462a8.447 8.447 0 0 0 5.031 2.781 1.155 1.155 0 0 0 .335-2.285 5.612 5.612 0 0 1-3.981-2.688l-1.154-1.846a2.475 2.475 0 0 0-3.058-.969L7.408 8.746A2.32 2.32 0 0 0 6 10.881v2.735a1.154 1.154 0 1 0 2.308 0v-2.77l2.077-.808",
    transform: "translate(-6 -1.5)",
    style: {
      fill: "#bfbfbf"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalkingIcon);
export default __webpack_public_path__ + "static/media/walking-icon.1e56a6f5e3ab5ba48aff9acc7d4b143f.svg";
export { ForwardRef as ReactComponent };